import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const AdvertisementPopupSkeleton = () => (
    <Group direction="v" alignItems="start">
        <FormItemSkeleton labelWidth={67}>
            <SkeletonItem width={360} height={150}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={118}>
            <SkeletonItem width={360} height={30}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={153}>
            <SkeletonItem width={360} height={30}/>
        </FormItemSkeleton>
    </Group>
);
